import { Checkbox, HStack, VStack, Text, Box } from '@chakra-ui/react';
import { FC, useCallback, useMemo } from 'react';
import { useDefaultStyles } from '../../../../hooks/useDefaultStyles';
import { PrimaryButton } from '../../../../lib/components/PrimaryButton';
import { NpsUserGroup } from './PrimumNpsModalShow';

interface ModalStep2Props {
  userGroup: NpsUserGroup,
  reasons: string[],
  setReasons: (v: string[]) => void,
  onNext: () => void,
}

export const ModalStep2: FC<ModalStep2Props> = ({
  userGroup,
  reasons,
  setReasons,
  onNext,
}) => {
  const { colors } = useDefaultStyles();

  const reasonsList = useMemo(() => {
    switch (userGroup) {
      case 'DETRACTOR':
        return [
          'Baixa qualidade ou profundidade do conteúdo',
          'Aulas muito densas',
          'Aulas desatualizadas ou repetitivas',
          'Material de apoio pouco útil ou com erros',
          'Dificuldade de navegação ou instabilidade da plataforma',
          'Plataforma lenta ou com bugs recorrentes',
          'Layout confuso ou pouco intuitivo',
          'Demora no atendimento ou falta de retorno',
          'Demandas financeiras não foram respondidas ou demoraram',
          'Respostas genéricas ou que não solucionaram o problema',
          'Comunicação desorganizada ou falha',
          'Não senti que o curso me ajudou a evoluir',
          'Esperava mais pelo valor pago',
          'Frustração com as promessas versus entrega',
        ];
      case 'PROSECUTOR':
        return [
          'Aulas didáticas, claras e de alta qualidade',
          'Material complementar muito útil e bem elaborado',
          'Organização dos conteúdos facilitou minha jornada',
          'Plataforma intuitiva e fácil de usar',
          'Experiência de navegação fluida',
          'Ferramentas e funcionalidades agregaram valor',
          'Suporte ágil e atencioso',
          'Senti que fui bem acolhido(a)',
          'Respostas personalizadas e resolutivas',
          'Me senti apoiado(a) na minha preparação',
          'Entregou mais do que eu esperava',
          'Estou confiante de que evoluí com o curso',
        ];
      default:
        return [
          'Conteúdo bom, mas poderia ser mais aprofundado',
          'Aulas claras, mas com pouco diferencial',
          'Material de apoio razoável',
          'Plataforma funcional, mas poderia ser mais fluida',
          'Alguns bugs ou instabilidades pontuais',
          'Layout pouco envolvente',
          'Suporte prestativo, mas demorado ou não resolve na primeira interação',
          'Respostas adequadas, mas demoradas ou sem empatia',
          'Boa experiência, mas ainda distante do encantamento',
          'Senti que valeu, mas poderia ter mais retorno pelo preço',
        ];
    }
  }, [userGroup]);

  const handleCheckReason = useCallback((value: string) => {
    const index = reasons.findIndex(it => it === value);
    const copy = [...reasons];
    if (index === -1) {
      copy.push(value);
      setReasons(copy);
      return;
    }

    copy.splice(index, 1);

    setReasons(copy);
  }, [reasons, setReasons]);

  const disable = useMemo(() => {
    return !reasons.length;
  }, [reasons]);

  return (
    <VStack align="left">
      <Box p="8px 16px" backgroundColor="#041223">
        <Text fontSize="20px" fontWeight="bold" color="#89B2F9">
          O que mais influenciou sua nota nesta avaliação? (Você pode selecionar
          mais de um motivo abaixo)
        </Text>
      </Box>
      <VStack align="left" spacing="16px" p="16px 24px">
        <VStack align="left" spacing="16px">
          {reasonsList.map((it, index) => {
            return (
              <HStack key={it} spacing="8px">
                <Checkbox
                  checked={reasons.includes(it)}
                  onChange={_ => handleCheckReason(it)}
                />
                <Text fontSize="14px">{it}</Text>
              </HStack>
            );
          })}
        </VStack>

        <PrimaryButton
          onClick={onNext}
          disabled={disable}
          fontSize="14px"
          backgroundColor={colors.customColors.lightBlue}
        >
          Próximo
        </PrimaryButton>
      </VStack>
    </VStack>
  );
};
